import { useLocalStorage } from '@rehooks/local-storage';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useGuestAccessHash = (selector) => {
    const [guestAccessHash, setGuestAccessHash] = useLocalStorage(selector, null);
    const { search } = useLocation();

    const queryParams = new URLSearchParams(search);
    const queryGuestAccessHash = queryParams.get('guest-access-hash');
    const shouldReturnStoredGuestAccessHash = !queryGuestAccessHash || queryGuestAccessHash === guestAccessHash;

    useEffect(() => {
        queryGuestAccessHash && setGuestAccessHash(queryGuestAccessHash);
    }, [shouldReturnStoredGuestAccessHash]);

    return {
        guestAccessHash: shouldReturnStoredGuestAccessHash ? guestAccessHash : null,
    };
};
